/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicareEstimates } from './MedicareEstimates';
import {
    MedicareEstimatesFromJSON,
    MedicareEstimatesFromJSONTyped,
    MedicareEstimatesToJSON,
    MedicareEstimatesToJSONTyped,
} from './MedicareEstimates';

/**
 * 
 * @export
 * @interface GetMedicareEstimates200Response
 */
export interface GetMedicareEstimates200Response {
    /**
     * 
     */
    data?: MedicareEstimates;
}

/**
 * Check if a given object implements the GetMedicareEstimates200Response interface.
 */
export function instanceOfGetMedicareEstimates200Response(value: object): value is GetMedicareEstimates200Response {
    return true;
}

export function GetMedicareEstimates200ResponseFromJSON(json: any): GetMedicareEstimates200Response {
    return GetMedicareEstimates200ResponseFromJSONTyped(json, false);
}

export function GetMedicareEstimates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicareEstimates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MedicareEstimatesFromJSON(json['data']),
    };
}

export function GetMedicareEstimates200ResponseToJSON(json: any): GetMedicareEstimates200Response {
    return GetMedicareEstimates200ResponseToJSONTyped(json, false);
}

export function GetMedicareEstimates200ResponseToJSONTyped(value?: GetMedicareEstimates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicareEstimatesToJSON(value['data']),
    };
}

